import { render, staticRenderFns } from "./PlatformForCustomer.vue?vue&type=template&id=298eb2f2&scoped=true&"
import script from "./PlatformForCustomer.vue?vue&type=script&lang=js&"
export * from "./PlatformForCustomer.vue?vue&type=script&lang=js&"
import style0 from "./PlatformForCustomer.vue?vue&type=style&index=0&id=298eb2f2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298eb2f2",
  null
  
)

export default component.exports